<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <taskSelect v-model="filters.etid" :lists.sync="taskLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">申请人：</div>
        <el-select class="filter__input" size="mini" v-model="filters.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">人群：</div>
        <el-select class="filter__input" size="mini" v-model="filters.people">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in peopleList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.euid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.eoid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="ml-auto">
        <button class="blue-small-btn" @click="dialogVisible = true">一键汇总</button>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          center>
          <span>是否立即汇总订单，生成兑换记录</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="earnSummaryOrderExchange">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <div class="flex jcb mt-20">
      <div class="filter">
        <button class="white-small-btn mr-20"  @click="toggleSelection(lists)">全选</button>
        <button class="white-small-btn mr-20"  @click="toggleSelection()">取消选择</button>
        <div class="mr-20" v-if="filters.status === 0 || filters.status === 4">
          <button class="white-small-btn"  @click="multiDialog = true">个人批量打款</button>
          <el-dialog
            title="提示"
            :visible.sync="multiDialog"
            width="30%"
            center>
            <span>是否导出兑换记录，使用个人批量打款</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="multiDialog = false">取 消</el-button>
              <el-button type="primary" @click="downloadPersonMultiExchange">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <button class="white-small-btn mr-20" @click="editMultiExchange" v-if="filters.status === 0 || filters.status === 4">合并打款</button>
        <div class="filter__item" v-if="filters.status === 1">
          <button class="blue-small-btn mr-10" @click="uploadDialog = !uploadDialog">上传</button>
        </div>
      </div>
      <div>
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
      </div>
    </div>
    <div class="flex jcb mt-20" v-if="filters.status === 0 || filters.status === 4">
      <div class="flex aic">
        <div class="mr-20">选择支付宝：</div>
        <el-radio-group v-model="pay_account">
          <el-radio :label="1" border size="small">极推支付宝</el-radio>
          <el-radio :label="2" border size="small">有只喵支付宝</el-radio>
        </el-radio-group>
      </div>
      <div>
        <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in handleList" :key="index" @click="changeHandle(index)">{{item.name}}</button>
        <button class="blue-small-btn ml-10" @click="earnExchangeUpdate">提交</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600" :summary-method="getSummaries" show-summary @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column prop="eeid" label="兑换ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="etid" label="广告" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('etid', scope.row.etid)">{{scope.row.title}}({{scope.row.etid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="euid" label="用户" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adUserDetail', query: {euid: scope.row.euid}}">{{scope.row.nickname}}({{scope.row.euid}})</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="method" label="支付方式" width="" align="center">
        <template slot-scope="scope">
          <div v-if="filters.status !== 0">
            <div v-if="scope.row.method == 2">个人批量打款</div>
            <div v-if="scope.row.method == 1">手动打款</div>
            <div v-if="scope.row.method == 0">企业支付宝</div>
          </div>
          <div v-else>
            <el-button type="primary" size="small" @click="displayHandDialog(scope.$index, scope.row.eeid)">手动打款</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pay_account" label="支付账户" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.pay_account == 2">有只喵支付宝</div>
          <div v-if="scope.row.pay_account == 1">极推支付宝</div>
          <div v-if="scope.row.pay_account == 0">个人号</div>
        </template>
      </el-table-column>
      <el-table-column prop="payout_type" label="打款类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.payout_type == 1">发票打款</div>
          <div v-if="scope.row.payout_type == 0">佣金打款</div>
        </template>
      </el-table-column>
      <el-table-column prop="alipay_name" label="真实名字" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('euid', scope.row.euid)">{{scope.row.alipay_name}}</div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="" label="类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.type == 1">银行卡</div>
          <div v-if="scope.row.type == 0">支付宝</div>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="alipay" label="账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment" label="订单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="estimate_commission" label="预估佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="打款金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="agency_fees" label="拍手费" width="" align="center">
      </el-table-column>
      <el-table-column prop="estimate_profit" label="预估利润" width="" align="center">
      </el-table-column>
      <el-table-column prop="profit" label="利润" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.profit < 0">
            <router-link class="fc-red pointer" target="_blank" :to="{path: '/earnOrder', query: {eoids: scope.row.eoids}}">{{scope.row.profit}}</router-link>
          </div>
          <div v-else>
            {{scope.row.profit}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="eoids" label="申请订单号" width="" align="center">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="underline fc-blue pointer" target="_blank" :to="{path: '/earnOrder', query: {eoids: scope.row.eoids}}">{{scope.row.eoids}}</router-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="" align="center" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <span class="underline fc-blue pointer" @click="editRemark(scope.$index)">{{scope.row.remark}}</span>
          </div>
          <div v-else>
            <i class="el-icon-edit" @click="editRemark(scope.$index)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="last_edit" label="编辑时间" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.last_edit)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" width="120" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 4">兑换失败</div>
          <div v-if="scope.row.status == 3">兑换成功</div>
          <div v-if="scope.row.status == 2">拒绝兑换</div>
          <div v-if="scope.row.status == 1">审核通过</div>
          <div v-if="scope.row.status == 0">等待审核</div>
        </template>
      </el-table-column>
      <el-table-column prop="response" label="结果" width="140" align="center" v-if="filters.status === 4">
      </el-table-column>
      <el-table-column prop="" label="操作" width="160" fixed="right" align="center" v-if="filters.status === 0 || filters.status === 4">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.isChoose">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="0">拒绝</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog :visible.sync="remarkDialog" size="tiny" width="600px">
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">备注:</div>
            <el-input class="dataForm__input" v-model="detail.remark" size="mini"></el-input>
          </div>
          <div class="flex mt-30">
            <div class="blue-large-btn mr-20" @click="earnExchangeEdit">保存</div>
            <div class="gray-large-btn" @click="remarkDialog = false">取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="创建收支请款记录"
      :visible.sync="handDialogVisible"
      width="30%"
      center>

      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">兑换ID:</div>
            <div class="">{{exchange_info.eeid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户:</div>
            <div class="">{{exchange_info.nickname}}({{exchange_info.euid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">广告:</div>
            <div class="">{{exchange_info.title}}({{exchange_info.etid}})</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">请款金额:</div>
            <div class="">{{exchange_info.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name ml40">收款二维码</div>
            <div class="headimg-container relative" style="width:250px">
              <uploadHeadImage :url.sync="exchange_info.account" :itype="5"></uploadHeadImage>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20">
        <span>是否选择手动打款，确定后将需要去收支列表打款</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editHand">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="合并打款" :visible.sync="multiExchangeDialog" size="tiny" width="800px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">兑换ID集合:</div>
            <el-input class="dataForm__input" v-model="multiExchangeInfo.eeids" size="mini" disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">总实付金:</div>
            <el-input class="dataForm__input" v-model="multiExchangeInfo.payment" size="mini" disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户ID:</div>
            <div class="">{{multiExchangeInfo.euid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">打款总金额:</div>
            <div class="">{{multiExchangeInfo.amount}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">支付方式:</div>
            <el-radio-group v-model="multiExchangeInfo.pay_type" @input="changePayType">
              <div class="dib mr-20">
                <el-radio :label="0">银行卡</el-radio>
                <el-radio :label="1">支付宝</el-radio>
                <el-radio :label="2">微信</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name ml40">收款账号</div>
            <el-input type="textarea" v-model="multiExchangeInfo.account" rows=4 placeholder="" size="mini" class="dataForm__input" width="200px"></el-input>
            <div class="headimg-container relative" style="width:250px">
              <uploadHeadImage :url.sync="multiExchangeInfo.account" :itype="5"></uploadHeadImage>
            </div>
          </div>
          <div class="flex mt-30">
            <div class="blue-large-btn mr-20" @click="earnMultiExchangeUpdate">保存</div>
            <div class="gray-large-btn" @click="multiExchangeDialog = false">取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="个人批量打款结果上传" :visible.sync="uploadDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">导入数据：</div>
            <el-upload
              ref="kttUpload"
              class="upload-demo"
              drag
              action=""
              :limit="1"
              accept=".xls,.xlsx"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :http-request="earnExchangeUpload"
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {earnExchangeLists, earnExchangeUpdate, earnMultiExchangeUpdate, earnSummaryOrderExchange, earnExchangeEdit, operLists, earnExchangeUpload, downloadPersonMultiExchange} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
import taskSelect from '../../../components/data-select/taskSelect.vue'
export default {
  name: 'earnExchange',
  mixins: [mixinList],
  components: {
    uploadHeadImage,
    taskSelect
  },
  data () {
    return {
      multipleSelection: [],
      lists: [],
      operLists: [],
      taskLists: [],
      listLoading: false,
      dialogVisible: false,
      multiDialog: false,
      remarkDialog: false,
      uploadDialog: false,
      handDialogVisible: false,
      multiExchangeDialog: false,
      filters: {
        p: 1,
        l: 20,
        status: '',
        eeids: '',
        eoid: '',
        opid: '',
        total: 0,
        euid: '',
        etid: '',
        people: ''
      },
      detail: {
        eeid: '',
        remark: ''
      },
      pay_account: 1,
      exchange_info: {
        eeid: '',
        euid: '',
        nickname: '',
        etid: '',
        title: '',
        amount: '',
        account: ''
      },
      multiExchangeInfo: {
        eeids: '',
        euid: '',
        nickname: '',
        title: '',
        amount: '',
        account: '',
        pay_type: 0,
        alipay: '',
        wechat: '',
        bank: ''
      },
      // 状态按钮
      statusList: [
        {
          name: '所有',
          value: '',
          status: 1
        },
        {
          name: '等待审核',
          value: 0,
          status: 0
        },
        {
          name: '审核通过',
          value: 1,
          status: 0
        },
        {
          name: '拒绝兑换',
          value: 2,
          status: 0
        },
        {
          name: '兑换成功',
          value: 3,
          status: 0
        },
        {
          name: '兑换失败',
          value: 4,
          status: 0
        }
      ],
      peopleList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '用户们',
          value: 1
        },
        {
          name: '自家们 ',
          value: 2
        }
      ],
      // 操作按钮
      handleList: [
        {
          name: '全部通过',
          value: 1,
          status: 0
        },
        {
          name: '全部拒绝',
          value: 2,
          status: 0
        }
      ]
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.dataTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.dataTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    opertorChange () {
      if (this.filters.opid !== '') {
        this.operLists.forEach((item) => {
          if (this.filters.opid === item.opid) {
            this.filters.euid = item.euid
          }
        })
      } else {
        this.filters.euid = ''
      }
    },
    conditionChange () {
      this.filters.p = 1
      this.getList()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['amount', 'payment', 'commission', 'final_payment', 'agency_fees'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    earnSummaryOrderExchange () {
      earnSummaryOrderExchange({}).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.dialogVisible = false
        }
      })
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
    },
    getOperLists () {
      let params = {
        market: 3,
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid,
              euid: item.euid,
              alipay: item.alipay,
              wechat: item.wechat,
              bank: item.bank
            }
          })
          this.orderOperLists = this.operLists.slice()
          this.operLists.unshift({
            nickname: '所有',
            opid: '',
            euid: ''
          })
        }
      })
    },
    uploadSuccess (res) {
      // 去掉文件列表
      this.$refs['kttUpload'].clearFiles()
    },
    uploadError (res) {
      // 去掉文件列表
      this.$refs['kttUpload'].clearFiles()
    },
    earnExchangeUpload (params) {
      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      earnExchangeUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.uploadDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    downloadPersonMultiExchange () {
      let eeidLists = []
      this.multipleSelection.forEach(item => {
        eeidLists.push(item['eeid'])
      })

      let content = ''

      if (eeidLists.length === 0) {
        content = '请选择需要打款的记录'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      let link = downloadPersonMultiExchange + '?eeids=' + eeidLists.join('|')

      setTimeout(() => {
        this.multiDialog = false

        this.getList()
      }, 2000)

      window.open(link, 'a')
    },
    getList () {
      let filters = this.filters
      let params = {
        // status: filters.status,
        p: filters.p,
        l: filters.l
      }
      if (filters.eeids !== '') {
        params.eeids = filters.eeids
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.etid !== '') {
        params.etid = filters.etid
      }
      if (filters.euid !== '') {
        params.euid = filters.euid
      }
      if (filters.people !== '') {
        params.people = filters.people
      }
      if (filters.eoid !== '') {
        params.eoid = filters.eoid
      }
      this.listLoading = true
      earnExchangeLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
            item.isCheck = false
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    earnExchangeEdit () {
      let params = {
        eeid: this.detail.eeid,
        remark: this.detail.remark
      }

      earnExchangeEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.remarkDialog = false
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    earnExchangeUpdate (success = '') {
      let lists = this.lists
      let accept = []
      let reject = []
      lists.forEach((item) => {
        if (item.isChoose === 1) {
          accept.push(item.eeid)
        }
        if (item.isChoose === 0) {
          reject.push(item.eeid)
        }
      })

      let params = {
        pay_account: this.pay_account,
        accept: accept.join('|'),
        reject: reject.join('|')
      }

      if (success !== '') {
        params.success = success
        params.account = this.exchange_info.account
      }

      earnExchangeUpdate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.handDialogVisible = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    earnMultiExchangeUpdate () {
      let params = {
        eeids: this.multiExchangeInfo.eeids,
        euid: this.multiExchangeInfo.euid,
        account: this.multiExchangeInfo.account
      }

      let content = ''

      if (params.eeids === '') {
        content = '请选择兑换记录'
      }

      if (params.account === '') {
        content = '请填写支付账号'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      earnMultiExchangeUpdate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.handDialogVisible = false
          this.multiExchangeDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value

      this.filters.p = 1
      this.getList()
    },
    displayHandDialog (index, eeid) {
      this.detail.eeid = eeid
      this.handDialogVisible = true
      this.lists.forEach((item) => {
        item.isChoose = ''
      })

      for (let key in this.exchange_info) {
        this.exchange_info[key] = this.lists[index][key]
      }
      this.exchange_info.account = ''
    },
    editRemark (index) {
      this.remarkDialog = true
      this.detail.remark = this.lists[index].remark
      this.detail.eeid = this.lists[index].eeid
    },
    editHand (eeid) {
      if (this.exchange_info.account === '') {
        this.$notify({
          title: '收款二维码没有传',
          type: 'error'
        })
        return
      }
      this.earnExchangeUpdate(this.detail.eeid)
      this.handDialogVisible = false
    },
    changeHandle (index) {
      this.handleList.forEach(item => {
        item.status = 0
      })
      this.handleList[index].status = 1
      switch (this.handleList[index].value) {
        case 1: // 全部通过
          this.lists.forEach((item) => {
            item.isChoose = 1
          })
          break
        case 2: // 全部拒绝
          this.lists.forEach((item) => {
            item.isChoose = 0
          })
          break
      }
    },
    changePayType () {
      let payType = parseInt(this.multiExchangeInfo.pay_type)

      if (payType === 0) {
        this.multiExchangeInfo.account = this.multiExchangeInfo.bank
      } else if (payType === 1) {
        this.multiExchangeInfo.account = this.multiExchangeInfo.alipay
      } else if (payType === 2) {
        this.multiExchangeInfo.account = this.multiExchangeInfo.wechat
      }
    },
    editMultiExchange () {
      let content = ''
      if (this.filters.euid === '' || this.filters.euid === 0) {
        content = '请先填写用户ID'
      }

      if (this.multipleSelection.length === 0) {
        content = '请选择需要打款的记录'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      this.multiExchangeDialog = true
      let payment = 0
      let amount = 0

      let consistent = []
      this.multipleSelection.forEach((item) => {
        consistent.push(item.eeid)
        amount = amount += item.amount
        payment = payment += item.payment
      })

      for (let key in this.multiExchangeInfo) {
        this.multiExchangeInfo[key] = ''
      }

      this.multiExchangeInfo.eeids = consistent.join('|')
      this.multiExchangeInfo.euid = this.filters.euid
      this.multiExchangeInfo.amount = amount
      this.multiExchangeInfo.payment = payment
      this.multiExchangeInfo.pay_type = 0

      if (this.filters.opid !== '') {
        this.operLists.forEach((item) => {
          if (parseInt(this.filters.opid) === item.opid) {
            this.multiExchangeInfo.alipay = item.alipay
            this.multiExchangeInfo.wechat = item.wechat
            this.multiExchangeInfo.bank = item.bank
            this.multiExchangeInfo.account = item.bank
          }
        })
      }
    }
  },
  mounted () {
    this.filters.eeids = this.$route.query.eeids || ''
    if (this.filters.eeids === '') {
      this.changeStatus(1)
    } else {
      this.getList()
    }
    this.getOperLists()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.euid': 'conditionChange',
    'filters.etid': 'conditionChange',
    'filters.opid': 'opertorChange',
    'filters.people': 'conditionChange',
    'filters.eoid': 'conditionChange'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnExchange.vue